const BizzerdTypes = {
    BUTTON : "button",
    ICON : "icon",
    TEXT: "text",
    IMAGE: "image",
    SHAPE: "shape"
};
Object.freeze(BizzerdTypes);
export default BizzerdTypes;